import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import { isNewStarterGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
import RussianBlockedBanner from './RussianBlockedBanner';
import StarterSuiteGWPPromotionBanner2023Q3 from './StarterSuiteGWPPromotionBanner2023Q3';
import { ENTERPRISE } from '../../constants/routing/Tabs';
import { usePageParams } from '../../hooks/usePageParams';

const BannerHierarchySection = ({
  screen
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const {
    tab
  } = usePageParams();
  const isRussianBlocked = useSelector(isRussianBlockedSelector);
  const isEligibleFor2023Q3StarterGWP = useSelector(isNewStarterGWP2023EligibleSelector);

  if (!hasPricingAndPurchasingSucceeded) {
    return null;
  }

  if (isRussianBlocked) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }

  if (isEligibleFor2023Q3StarterGWP && tab !== ENTERPRISE) {
    return /*#__PURE__*/_jsx(StarterSuiteGWPPromotionBanner2023Q3, {
      screen: screen
    });
  }

  return null;
};

export default BannerHierarchySection;